import { FC } from 'react'
import { Box, Grid, Skeleton } from '@mui/material'
import { ON_DARK_SX, SURFACE_SX } from './SkeletonParts'

const CARD_COUNT = 6

const GameCardSkeleton: FC = () => (
  <Grid item xs={12} sm={6} lg={4} display="flex">
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      gap="16px"
      width="100%"
      minHeight={160}
      p={3}
      borderRadius="12px"
      sx={SURFACE_SX}
    >
      <Skeleton
        variant="rounded"
        width={64}
        height={24}
        sx={{ ...ON_DARK_SX, position: 'absolute', top: 16, left: 16, borderRadius: '999px' }}
      />
      <Skeleton
        variant="rounded"
        width={42}
        height={42}
        sx={{ ...ON_DARK_SX, position: 'absolute', top: 16, right: 16, borderRadius: '8px' }}
      />
      <Box display="flex" flexDirection="column" gap="16px" mt="52px">
        <Skeleton width="65%" height={22} sx={ON_DARK_SX} />
        <Box>
          <Skeleton width="100%" sx={ON_DARK_SX} />
          <Skeleton width="80%" sx={ON_DARK_SX} />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gap="8px">
        <Skeleton width="50%" height={24} sx={ON_DARK_SX} />
        <Box
          height={48}
          borderRadius="6px"
          px={2}
          display="flex"
          alignItems="center"
          sx={SURFACE_SX}
        >
          <Skeleton width="60%" sx={ON_DARK_SX} />
        </Box>
        <Skeleton variant="rounded" height={44} sx={{ ...ON_DARK_SX, borderRadius: '8px' }} />
      </Box>
    </Box>
  </Grid>
)

export const GameCardsSkeleton: FC = () => (
  <>
    {Array.from({ length: CARD_COUNT }).map((_, i) => (
      <GameCardSkeleton key={i} />
    ))}
  </>
)
